import React, { useMemo } from 'react'
import noop from 'lodash/noop'
import { useRouter } from 'next/router'

import Affiliate from 'src/comps/Affiliate'
import ScoreReviews from 'src/comps/ScoreReviews'
import PropertyTitle from './property-title'
import ShareModal from 'client/components/Share/Modal/ShareModal'
import type { PropertyAPIResponse } from 'src/types/property'

import styles from './styles.module.css'
import { affiliateHasLogo } from 'src/comps/Affiliate/functions'
import LikePropertyButton from './like-property-button'

interface TitleProps {
  property: PropertyAPIResponse
  onRatingsClick?: () => void
}

const HotelDetailTitle: React.FC<TitleProps> = ({ property, onRatingsClick = noop }) => {
  const address = useMemo(
    () =>
      property.neighborhood
        ? `${property.address} ${property.neighborhood}, ${property.city}`
        : `${property.address} ${property.city}`,
    [property]
  )

  const router = useRouter()
  const affiliateId = router.query.aid as string

  return (
    <section data-testid="title" className={styles.sectionBase}>
      {affiliateHasLogo(affiliateId) && (
        <div className={styles.affiliateContainer}>
          <Affiliate id={affiliateId} />
        </div>
      )}
      <div className={styles.titleAndShareContainer}>
        <PropertyTitle
          address={address}
          distance={property.distance}
          isInCenter={property.isInCenter}
          name={property.name}
          propertyId={property.id}
          stars={property.stars}
        />
      </div>
      <div className={styles.scoreReviewsContainer}>
        <div>
          <ScoreReviews
            comments={property.ratings?.count ?? 0}
            score={property.ratings?.score ?? 0}
            handleClick={onRatingsClick}
          />
        </div>
        <div className={styles.titleButtonsContainer}>
          <ShareModal propertyId={property.id} />
          <div className={styles.likeBtnWrapper}>
            <LikePropertyButton
              propertyId={property.id.toString()}
              hide={process.env.NEXT_PUBLIC_IS_LIKE_ENABLED === 'false'}
            />
          </div>
        </div>
      </div>
    </section>
  )
}

export default HotelDetailTitle
